// One persistent scene. Wheel gestures and native mobile swipes turn one page;
// the ball and tilt pad keep exclusive ownership of their manipulation gestures.
export function installScrollStory({order,getMode,setMode,blocked=()=>false,reduced=false,onResize=()=>{},onNavigate=()=>{}}){
 const shell=document.querySelector('#story-shell'),cue=document.querySelector('#story-next');
 if(!shell||!cue||!Array.isArray(order)||order.length<2)throw new Error('Scroll story requires a shell, cue, and chapters.');
 const bound=n=>Math.max(0,Math.min(order.length-1,n));
 let pageH=innerHeight,current=bound(order.indexOf(getMode())),lockUntil=0;
 let timer=0,raf=0,wheel=0,lastWheel=-Infinity,wheelConsumed=false,touch=null;
 const removers=[];
 function listen(target,type,handler,options){target.addEventListener(type,handler,options);removers.push(()=>target.removeEventListener(type,handler,options));}
 function paint(){
  const progress=bound(scrollY/pageH);
  shell.style.setProperty('--story-progress',progress/(order.length-1));
  const mobile=innerWidth<=700;
  document.querySelector('#story-page').textContent=String(current+1).padStart(2,'0')+(mobile?'/':' / ')+String(order.length).padStart(2,'0');
  const next=order[(current+1)%order.length],title=next==='walk'?'Your Walk':next[0].toUpperCase()+next.slice(1);
  cue.querySelector('.cue-label').textContent=current===order.length-1?'Back to Paths':'Next: '+title;
  cue.querySelector('.cue-instruction').textContent=current===order.length-1?(mobile?'Tap to return':'Click to return'):(mobile?'Swipe up or tap to continue':'Scroll down or click to continue');
  cue.setAttribute('aria-label',current===order.length-1?'Return to Paths':'Next chapter: '+order[current+1]);
 }
 function apply(index,method){
  index=bound(index);
  if(current!==index||getMode()!==order[index]){if(method)onNavigate({chapter:order[current],target_chapter:order[index],navigation_method:method});current=index;setMode(order[index]);}
  paint();
 }
 function goTo(name,{instant=false,method}={}){
  const index=order.indexOf(name);if(index<0)return;
  clearTimeout(timer);lockUntil=performance.now()+(instant||reduced?120:750);
  apply(index,method);scrollTo({top:index*pageH,behavior:instant||reduced?'instant':'smooth'});
 }
 function onScroll(){
  cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{
   if(blocked())return;
   // Do not flash intermediate chapters during the user's swipe.
   if(!touch&&performance.now()>lockUntil)apply(Math.round(scrollY/pageH),'scroll');else paint();
   clearTimeout(timer);timer=setTimeout(()=>{
    if(touch||blocked()||performance.now()<lockUntil)return;
    const i=bound(Math.round(scrollY/pageH));
    if(Math.abs(scrollY-i*pageH)>2)goTo(order[i]);
   },180);
  });
 }
 function onWheel(e){
  if(e.ctrlKey||e.metaKey||e.target.closest?.('dialog')||Math.abs(e.deltaX)>Math.abs(e.deltaY))return;
  if(blocked()){if(!document.querySelector('dialog[open]'))e.preventDefault();return;}
  const now=performance.now();e.preventDefault();
  // An inertial trackpad tail must not advance a second chapter.
  if(now-lastWheel>180){wheel=0;wheelConsumed=false;}lastWheel=now;
  if(now<lockUntil||wheelConsumed)return;
  wheel+=e.deltaY*(e.deltaMode===1?16:e.deltaMode===2?pageH:1);
  if(Math.abs(wheel)>=55){const next=bound(current+Math.sign(wheel));wheel=0;wheelConsumed=true;if(next!==current)goTo(order[next],{method:'scroll'});}
 }
 function onTouchStart(e){
  if(blocked()||e.touches.length!==1||e.target.closest?.('#ball-hit,#tilt-pad,button,a,dialog,input,textarea,select')){touch=null;return;}
  const p=e.touches[0];touch={id:p.identifier,x:p.clientX,y:p.clientY,index:current};
  clearTimeout(timer);
 }
 function onTouchEnd(e){
  if(!touch)return;
  const t=touch;touch=null;
  const p=Array.from(e.changedTouches).find(p=>p.identifier===t.id);
  if(!p||blocked())return;
  const dx=p.clientX-t.x,dy=p.clientY-t.y;
  const moved=Math.abs(dy)>Math.max(42,Math.min(88,pageH*.09))&&Math.abs(dy)>Math.abs(dx)*1.15;
  // No matter how far native momentum travels, a single swipe turns one page.
  goTo(order[bound(t.index+(moved?-Math.sign(dy):0))],{method:'swipe'});
 }
 function onKey(e){
  if(e.target.closest?.('dialog,input,textarea,select')||blocked())return;
  if(e.key==='PageDown'||e.key==='PageUp'){e.preventDefault();goTo(order[bound(current+(e.key==='PageDown'?1:-1))],{method:'keyboard'});}
 }
 function resize(){
  pageH=innerHeight;
  shell.style.height=`${pageH*order.length}px`;
  shell.style.setProperty('--story-viewport',`${pageH}px`);
  onResize();
  lockUntil=performance.now()+250;
  scrollTo({top:current*pageH,behavior:'instant'});paint();
 }
 listen(window,'scroll',onScroll,{passive:true});listen(window,'wheel',onWheel,{passive:false});
 listen(window,'touchstart',onTouchStart,{passive:true});listen(window,'touchend',onTouchEnd,{passive:true});
 listen(window,'touchcancel',()=>{if(touch){const i=touch.index;touch=null;goTo(order[i]);}},{passive:true});
 listen(window,'keydown',onKey);listen(window,'hashchange',()=>goTo(location.hash.slice(1),{method:'hash'}));listen(window,'resize',resize);
 listen(cue,'click',()=>{if(!blocked())goTo(order[(current+1)%order.length],{method:'next_button'});});
 const previousRestoration=history.scrollRestoration;
 if('scrollRestoration' in history)history.scrollRestoration='manual';
 resize();goTo(order[current],{instant:true});
 return {goTo,resize,get current(){return current;},destroy(){clearTimeout(timer);cancelAnimationFrame(raf);removers.forEach(remove=>remove());if(previousRestoration)history.scrollRestoration=previousRestoration;}};
}
